// @flow

import {
	momentRepr as momentReprISO,
	DATE_FORMAT as DATE_FORMAT_ISO,
} from 'ko-extender-repr-moment-from-iso';

import {
	momentRepr as momentReprDefault,
	DATE_FORMAT as DATE_FORMAT_DEFAULT,
} from 'ko-extender-repr-moment';

// FIXME: should not allow any class, only costructable and jsable
export const createJSableEntityListMapExtender = (Entity: Class<any>, args: *) => ({
	fromJSMap: (list: any) => list.map(item => {
		const instance = new Entity(...args);
		instance.fromJS(item);
		return instance;
	}),
	toJSMap: (items: any) => items.map(i => i.toJS()),
});

// FIXME: should not allow any class, only costructable and jsable
export const createIdentifiedEntityListMapExtender = (Entity: Class<any>, args: *) => ({
	fromJSMap: (list: any) => list.map(item => {
		const instance = new Entity(...args);
		instance.fromJS(item);
		instance.ID = item.ID;
		return instance;
	}),
	toJSMap: (items: any) => items.map(i => i.toJS()),
});

export const createJSableMomentFromISOMapExtender = () => ({
	fromJSMap: (date: any) => {
		const input = momentReprISO(date);
		return input.isValid() ? input.format(DATE_FORMAT_DEFAULT) : null;
	},
	toJSMap: (date: any) => {
		const output = momentReprDefault(date);
		return output.isValid() ? output.format(DATE_FORMAT_ISO) : null;
	},
});

export const createJSableObjExtender = (Entity: Class<any>, args: * = {}) => ({
	fromJSMap: (item: any) => {
		const instance = new Entity(...args);
		instance.fromJS(item);
		return instance;
	},
});

export const createJSableNullableObjExtender = (Entity: Class<any>, args: * = {}) => ({
	fromJSMap: (item: any) => {
		if (item) {
			const instance = new Entity(...args);
			instance.fromJS(item);
			return instance;
		}

		return item;
	},
});

export const createJSableMultiTypeListMapExtender = (entities: {
	[type: string]: {
		entity: any,
		options: any,
	}
}) => ({
	fromJSMap: (list: { type: string }[]) => list.map(item => {
		const {entity: Entity, options = {}} = entities[(item.type || item.Type)];
		if (Entity) {
			const instance = new Entity(options);
			instance.fromJS(item);
			return instance;
		}
		console.error(`${item.type} doesn't present in entity list`);
	}),
	toJSMap: (items: any) => items.map(i => i.toJS()),
});